export default __webpack_public_path__ + "static/media/AIA.4947d586.svg";